import { useForm } from 'react-hook-form';
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { Label } from "../../../components/Label/Label";
import PageTitle from '../../../components/PageTitle/PageTitle';
import HelperService from '../../../utility/HelperService';
import { useEffect, useState } from 'react';
import routePaths from '../../../Navigation/routePaths';
import { ProjectUnitInterface, ProjectUnitState } from '../ProjectUnitTypes';
import { permissionsInterface, reduxInitialState } from '../../onBoarding/onBoardingTypes';
import { projectUnitCreateRequest } from '../ProjectUnitAction';
import { useParams } from 'react-router-dom';

interface propData {
    onSubmit: (params: ProjectUnitInterface) => void;
};

const CreateProjectUnit = (props: propData) => {
    const projectUnitData: ProjectUnitState = useSelector((state: reduxInitialState) => state.ProjectUnitReducer);
    const { handleSubmit, formState: { errors, isValid }, control, watch, register, reset, setValue } = useForm<ProjectUnitInterface>({});
    const watchAllFields = watch();
    const { id }: any = useParams();
    const isEdit = window.location.pathname === routePaths.PROJECT_UNIT_UPDATE.path;
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
        }
    }, [token])

    useEffect(() => {
        if (permissions) {
            if (window.location.pathname === routePaths.PROJECT_UNIT_UPDATE.path && projectUnitData && projectUnitData.editProject && !HelperService.isEmptyObject(projectUnitData.editProject) && permissions && permissions.can_update) {
                reset(projectUnitData.editProject);
                setValue('is_corner', projectUnitData.editProject.is_corner == true ? "true" : projectUnitData.editProject.is_corner == false ? "false" : "");
                setValue('is_mortgage', projectUnitData.editProject.is_mortgage == true ? "true" : projectUnitData.editProject.is_mortgage == false ? "false" : "");
                setTimeout(() => {
                    setValue('area', projectUnitData.editProject.area)
                }, 500);
            } else if (window.location.pathname === routePaths.PROJECT_UNIT_CREATE.path + id && permissions && permissions.can_write) {
                !id && window.history.back();
                reset({});
                setValue('project_id', id);
            } else {
                window.history.back();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissions]);

    useEffect(() => {
        if (watchAllFields.length && watchAllFields.width) {
            const area = parseFloat(watchAllFields.length.toString()) * parseFloat(watchAllFields.width.toString());
            setValue('area', isNaN(area) ? "" as any : area);
        }
    }, [watchAllFields.length, watchAllFields.width]);

    const onSubmit = async (data: ProjectUnitInterface) => {
        data.is_corner = data.is_corner === "true" ? true : false;
        data.is_mortgage = data.is_mortgage === "true" ? true : false;
        props.onSubmit(data);
    };

    const directionOptions = ['NORTH', 'SOUTH', 'EAST', 'WEST', 'NORTH_EAST', 'NORTH_WEST', 'SOUTH_EAST', 'SOUTH_WEST'];



    return (
        <div className="app-page page-dashboard">
            <div className="d-flex justify-content-between align-items-center ">
                <PageTitle title={window.location.pathname === routePaths.PROJECT_UNIT_UPDATE.path ? "Edit Project Unit" : "Add New Project Unit"} backArrow={true} />

            </div>

            {permissions && (permissions.can_update || permissions.can_write) && <Card style={{ height: '100%' }}>
                <Card.Body>
                    <form className=" form-style" onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Unit Name</Form.Label>
                                    <span className="text-danger">*</span>
                                    <div className="input-group mb-1">
                                        <input
                                            type="text"
                                            className="form-control ps-3 p-2"
                                            placeholder="Unit Name"
                                            {...register("unit_name", { required: true })}
                                        />
                                    </div>
                                    {errors.unit_name && (
                                        <div className="login-error mb-3">
                                            <Label title={watchAllFields.unit_name ? "Min. 2 and Max. 30 charecetrs" : "Please enter unit name"} modeError={true} />
                                        </div>
                                    )}
                                </Form.Group>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Width (in feet)</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control ps-3 p-2"
                                                    placeholder="Width"
                                                    {...register("width", { required: true, min: 1 })}
                                                    onKeyPress={HelperService.allowNewDecimalValue}
                                                />
                                            </div>
                                            {errors.width && (
                                                <div className="login-error mb-3">
                                                    <Label title={"Please enter width"} modeError={true} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Length (in feet)</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control ps-3 p-2"
                                                    placeholder="Length"
                                                    {...register("length", { required: true, min: 1 })}
                                                    onKeyPress={HelperService.allowNewDecimalValue}
                                                />
                                            </div>
                                            {errors.length && (
                                                <div className="login-error mb-3">
                                                    <Label title={"Please enter length"} modeError={true} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Direction</Form.Label>
                                            {/* <span className="text-danger">*</span> */}
                                            <Form.Select  {...register("facing_direction", { required: false })}>
                                                <option value="">Select Direction</option>
                                                {
                                                    directionOptions.map((item: any, index) => {
                                                        return (
                                                            <option key={index} value={item}>{item.replace("_", " ")}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                            {/* {
                                        errors.facing_direction &&
                                        <div className="login-error mb-3">
                                            <Label
                                                title={"Please select direction"}
                                                modeError={true}
                                            />
                                        </div>
                                    } */}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Registration Power</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control ps-3 p-2"
                                                    placeholder="Registration Power"
                                                    {...register("registration_power", { required: true })}
                                                />
                                            </div>
                                            {errors.registration_power && (
                                                <div className="login-error mb-3">
                                                    <Label title={"Please enter registration power"} modeError={true} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Col>

                            <Col lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Comment</Form.Label>
                                    {/* <span className="text-danger">*</span> */}
                                    <div className="input-group mb-1 mt-1">
                                        <textarea rows={4} className="form-control ps-3 p-2" placeholder="Comment" value={watch().comment} {...register("comment", { required: false })} />
                                    </div>
                                    {/* {
                                        errors.comment &&
                                        <div className="login-error mb-3">
                                            <Label
                                                title={"Please enter comment"}
                                                modeError={true}
                                            />
                                        </div>
                                    } */}
                                </Form.Group>
                                <Row>
                                    <Col lg={6} >
                                        <Form.Group className="mb-3">
                                            <Form.Label>Area (in sq. feet)</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control ps-3 p-2"
                                                    placeholder="Area"
                                                    {...register("area", { required: true, min: 1 })}
                                                    onKeyPress={HelperService.allowNewDecimalValue}
                                                />
                                            </div>
                                            {errors.area && (
                                                <div className="login-error mb-3">
                                                    <Label title={"Please enter area"} modeError={true} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Is it a corner plot ?</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className='d-flex gap-3'>
                                                <Form.Check
                                                    type="radio"
                                                    label="Yes"
                                                    value="true"
                                                    {...register('is_corner', { required: true })}
                                                    id="corner_yes"
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="No"
                                                    value="false"
                                                    {...register('is_corner', { required: true })}
                                                    id="corner_no"
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Is it a mortgage plot ?</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className='d-flex gap-3'>
                                                <Form.Check
                                                    type="radio"
                                                    label="Yes"
                                                    value="true"
                                                    {...register('is_mortgage', { required: true })}
                                                    id="mortgage_yes"
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="No"
                                                    value="false"
                                                    {...register('is_mortgage', { required: true })}
                                                    id="mortgage_no"
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>

                                </Row>

                            </Col>

                            <Col lg={3}></Col>
                            <Col lg={6} className="text-center">
                                <Button className="btn-brand-1 me-3 w-50" type="submit" id="project_create_update_btn">{window.location.pathname === routePaths.PROJECT_UNIT_UPDATE.path ? "Update" : 'Save'}</Button>
                            </Col>
                        </Row>
                    </form>
                </Card.Body>
            </Card>}
        </div>
    )
};

const mapDispatchToProps = (dispatch: any) => ({
    onSubmit: (params: ProjectUnitInterface) => dispatch(projectUnitCreateRequest(params)),
});

export default connect(null, mapDispatchToProps)(CreateProjectUnit);